import React, { useContext } from "react";
import "./accountFavorites.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";

const AccountFavorites = () => {
	const { language } = useContext(CombinedContext);

	// Mock favourites array for now – replace with real API data when ready
	const favourites = []; // e.g. [{ shopId, name, image, address }]

	return (
		<div className="sf-favorites-page">
			<h2 className="sf-fav-title">{translations[language]?.account?.favorites.title}</h2>

			{favourites.length === 0 ? (
				<div className="sf-fav-empty">
					<p>{translations[language]?.account?.favorites.empty}</p>
					<button className="sf-fav-btn" onClick={() => window.location.href = "/"}>
						{translations[language]?.account?.favorites.explore}
					</button>
				</div>
			) : (
				<div className="sf-fav-grid">
					{favourites.map((shop) => (
						<div key={shop.shopId} className="sf-fav-card">
							<img src={shop.image || "/default_shop.png"} alt={shop.name} />
							<div className="sf-fav-info">
								<p className="sf-fav-name">{shop.name}</p>
								<p className="sf-fav-address">{shop.address}</p>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default AccountFavorites;
